<template>
  <div>
    <div>
      <h1 class="text-center">Broadcast Messages</h1>
      <div>
        <List />
      </div>
    </div>
  </div>
</template>

<script>
import List from "./ListBroadcastMessage.vue";

export default {
  components: {
    List,
  },
};
</script>
